<template>
  <span class="w-full relative">
    <button class="w-full lg:w-186 text-12 lg:text-14 uppercase rounded-md px-24 py-10 border border-light-gray-4 focus:outline-none" @click="show = ! show">
      {{ sortByText }}
      <i class="fas fa-sort ml-8"></i>
    </button>
    <span
      v-if="show"
      class="block absolute bg-white z-20 w-186 right-0 mt-10 border border-light-gray-4 rounded-md shadow-lg">
        <span
          v-for="sort in filters.sortBy.options"
          class="px-16 py-10 block focus:outline-none hover:underline hover:text-orange cursor-pointer text-right"
          @click="select(sort.value), sortByText = sort.text">
          {{ sort.text }}
        </span>
      </span>
  </span>
</template>

<script>
export default {
  inject: ['filters', 'query', 'queryActions'],

  data () {
    return {
      sortByText: "Sort By",
      show: false,
    }
  },

  computed: {
    sortedBy () {
      return this.filters.sortBy.options.find(option => option.value === this.query.sortBy)
    },

  },

  methods: {
    select (value) {
      this.queryActions.sync({ sortBy: value, page: 1 })
      this.show = false
    }
  }
}
</script>
